/* global axios */
import ApiClient from './ApiClient';

class CampaignsAPI extends ApiClient {
  constructor() {
    super('campaigns', { accountScoped: true });
  }

  reprocess(id) {
    return axios.post(`${this.url}/${id}/reprocess`);
  }

  hardDelete(id) {
    return axios.delete(`${this.url}/${id}/hard_delete`);
  }

  pause(id) {
    return axios.post(`${this.url}/${id}/pause`);
  }

  resume(id) {
    return axios.post(`${this.url}/${id}/resume`);
  }
}

export default new CampaignsAPI();
